import * as React from 'react';

import { Button } from '../../button/button.tsx';

import './chip-item.css';

interface ChipItemProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> {
  label: string;
  size?: 'small' | 'medium' | 'large';
  kind?: 'neutral' | 'color' | 'danger' | 'disabled';
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const ChipItem = React.forwardRef<HTMLDivElement, ChipItemProps>(
  ({ label, size = 'small', kind = 'color', disabled, onClick, ...props }, ref) => {
    return (
      <div className={`chip-item ci-${size} ci-${kind}`} ref={ref} {...props}>
        {label}
        <Button
          asRemoveIcon={kind}
          disabled={disabled}
          onClick={disabled ? undefined : onClick}
        />
      </div>
    );
  },
);

export { ChipItem };
